import { useEffect, useRef, useState } from "react";
import { Check, ChevronDown } from "lucide-react";

export const METIERS = [
  { id: "architecte", label: "Architecte" },
  { id: "architecte_interieur", label: "Architecte d'intérieur" },
];

export default function TradeSelect({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(0);
  const boxRef = useRef(null);
  const btnRef = useRef(null);
  const current = METIERS.find((m) => m.id === value) || METIERS[0];

  useEffect(() => {
    const onDoc = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const openMenu = () => {
    setActive(Math.max(0, METIERS.findIndex((m) => m.id === value)));
    setOpen(true);
  };

  const choose = (id) => {
    onChange(id);
    setOpen(false);
    btnRef.current?.focus();
  };

  const onKey = (e) => {
    if (!open) {
      if (["ArrowDown", "ArrowUp", "Enter", " "].includes(e.key)) {
        e.preventDefault();
        openMenu();
      }
      return;
    }
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      setActive((a) => (a + 1) % METIERS.length);
    } else if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      choose(METIERS[active].id);
    } else if (e.key === "Escape" || e.key === "Tab") {
      setOpen(false);
    }
  };

  return (
    <div ref={boxRef} className="relative shrink-0">
      <button
        ref={btnRef}
        type="button"
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={`Ton métier : ${current.label}`}
        data-testid="trade-select"
        onClick={() => (open ? setOpen(false) : openMenu())}
        onKeyDown={onKey}
        className="flex h-10 items-center gap-1 whitespace-nowrap rounded-full pl-3 pr-2 text-[14px] font-medium text-ink transition-colors duration-150 hover:bg-surface-2 focus-visible:outline-offset-0"
      >
        <span data-testid="trade-select-value">{current.label}</span>
        <ChevronDown className={`h-4 w-4 text-muted transition-transform duration-150 ${open ? "rotate-180" : ""}`} strokeWidth={1.75} />
      </button>
      {open && (
        <ul
          role="listbox"
          aria-label="Ton métier"
          data-testid="trade-options"
          className="fade-up absolute left-0 top-[calc(100%+8px)] z-40 min-w-[230px] overflow-hidden rounded-card border border-line bg-surface py-1 shadow-modal"
        >
          {METIERS.map((m, i) => (
            <li
              key={m.id}
              role="option"
              aria-selected={m.id === value}
              data-testid={`trade-option-${m.id}`}
              onMouseEnter={() => setActive(i)}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => choose(m.id)}
              className={`flex cursor-pointer items-center justify-between gap-3 px-4 py-2.5 text-left text-[15px] text-ink ${i === active ? "bg-surface-2" : ""}`}
            >
              {m.label}
              {m.id === value && <Check className="h-4 w-4 text-accent" strokeWidth={2} />}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
